(function () {
    'use strict';

    angular
        .module('invesfleet')
        .controller('ClientsListController', ClientsListController);


    ClientsListController.$inject = [
        '$templateCache',
        'clientService',
        '$scope',
        '$rootScope',
        '$state',
        '$filter', 
        'notificationService',
        '$timeout',
        'genericDataService',
        'userService',
        'simpleModalService',
        'common',
        'uiGridConstants',
        'restrictionService'
    ];
    
    function ClientsListController(
        $templateCache,
        clientService,
        $scope,
        $rootScope,
        $state,
        $filter,
        notificationService,
        $timeout,
        genericDataService,
        userService,
        simpleModalService,
        common,
        uiGridConstants,
        restrictionService
    ) {
        // jshint maxstatements:false

        /* PRIVATE VARIABLES */
        var templates = {
			accionesCellTemplate: $templateCache.get('app/views/tablesTemplates/generic/accionesCellTemplate.html'),
			rowTemplate: $templateCache.get('app/views/tablesTemplates/generic/rowTemplate.html'),
			clienteCellTemplate: $templateCache.get('app/views/tablesTemplates/clients/clienteCellTemplate.html'),
        };

        var paginationOptions = {
            pageNumber: 1,
            pageSize: 25,
            sort: null
        };
        var sorting = {
            field: null,
            direction: null
        };

        var vm = this;
        vm.restrictionService = restrictionService; 
        vm.appliedFilters = [];
        $scope.gridData = [];
        vm.gridData = []; 
		vm.genericDataService = genericDataService;
		vm.listaClientesActivos = 0;
		vm.focusedRow = null;
        vm.loadingInformation = true;
        vm.rowCount = 0;
		vm.firstLoaded = false;
		vm.loaded = false; 
		vm.dadosBaja = 'Mostrar dados de baja';
		vm.skip = 25;
		vm.take = 0;
        vm.frequencyFields = [
            'nif',
            'id',
            'empresaNombre',
            'nombre', 
            'direccion',
            'poblacion',
            'provincia',
            'telefono'
        ];

		vm.allClientsResultList = [];
		vm.allClientsResultListWithFilters = [];
		vm.genericData = {
			estadoClientes: {
                list: [
                    { 'nombre': 'Activos', 'id': '0' }, 
					{ 'nombre': 'Clientes dados de baja', 'id': '1' }, 
                    { 'nombre': 'Todos', 'id': '2' }
                ],
                selected:
                    { 'nombre': 'Activos', 'id': '0' }
            },
            empresas: {
                list: [],
                loading: true,
                selected: null
            }
        };

        vm.gridOptions = {
            rowTemplate: templates.rowTemplate,
            
            paginationPageSizes: [25, 50, 75],
            paginationPageSize: 25,
			useExternalPagination: true,

            enableRowSelection: true,
            multiSelect: true,

            enableColumnResizing: true,

            enableColumnMenus: false,
            treeRowHeaderAlwaysVisible: false,
            virtualizationThreshold: 200,
			primaryKey: 'clienteId',
            columnDefs: [
				{
					field: 'Initials',
					displayName: '',
					width: 60,
					resizable: true,
					enableHiding: false,
					cellTemplate: templates.clienteCellTemplate
				},
				/*{
					field: 'estado',
					displayName: 'Estado',
					maxWidth: 120,
					resizable: true,
					cellTemplate: 
						'<div class="ui-grid-cell-contents">{{row.entity.estado == 0? "Activo" : "Baja"}}</div>'
				},*/
                {
                    name: 'id',
                    displayName: 'Id',
                    width: 70,
					resizable: true,
					sort: { priority: 1, direction: 'desc' }
				},
				{
					name: 'nombre',
               		cellClass: 'strong',
					displayName: 'Nombre',
					width: 230,
					resizable: true
				},
				{
					name: 'nif',
					displayName: 'NIF',
                    width: 100,
					resizable: true
				},
				{
					name: 'direccion',
					displayName: 'Dirección',
					resizable: true
				},
				{
					name: 'poblacion',
					displayName: 'Población',
					resizable: true
				},
				{
					name: 'provincia',
					displayName: 'Provincia',
					resizable: true
				},
				{
					name: 'telefono',
					displayName: 'Teléfono',
                    width: 110,
					resizable: true
				},
				{
					//field: 'empresaNombre',
					name: 'empresaNombre',
					displayName: 'Empresa',
					resizable: true

				},
                {
                    field: 'actions',
                    displayName: 'Acciones',
                    width: 90,
                    resizable: true,
                    cellClass: 'overflow',
					cellTemplate: templates.accionesCellTemplate,
					enableSorting: false
                }

            ],
            data: 'gridData',
            onRegisterApi: function (gridApi) {
                vm.gridApi = gridApi;
                vm.gridApi.grid.options.enableExpandAll = false;

                vm.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
                    if (sortColumns.length > 0) {
                        sorting.field = sortColumns[0].field;
                        sorting.direction = sortColumns[0].sort.direction;
                    } else {
                        sorting = { field: null, direction: null };
					}
					doSkipTake();
					applyPagination();
                });
                vm.gridApi.pagination.on.paginationChanged($scope, function (newPage, pageSize) {
                    paginationOptions.pageNumber = newPage;
                    paginationOptions.pageSize = pageSize;
					doSkipTake();
					applyPagination();


                });
            }
		};

		vm.selectAll = selectAll;
        vm.clearAll = clearAll;
        vm.invertSelection = invertSelection;
        vm.selectOrClear = selectOrClear;
		vm.showHideFilterBar = showHideFilterBar;
		vm.goToEdit = goToEdit;
		vm.deleteAllItems = deleteAllItems;
		vm.changeGrid = changeGrid;
		vm.remove = remove;
		vm.onCompanyChange = onCompanyChange;
		vm.getBrandLogo = getBrandLogo;
		vm.focusRow = focusRow;
		vm.isFocused = isFocused;
		vm.deleteSearchData = deleteSearchData;
		vm.filterGrid = filterGrid;
		vm.refreshGrid = refreshGrid;
		vm.estadoBajaChange = estadoBajaChange;
		vm.refreshData = refreshData; 

        vm.clearSearcher = clearSearcher;
        vm.searchText = '';
        vm.onSelectEmpresasClick = onSelectEmpresasClick;
        vm.selectEmpresasText = 'Todos';

        vm.tab = $rootScope.tabManager.tabs[$rootScope.tabManager.indexOfName('clientes')];

		(function () {

			var state = $rootScope.stateStorage[vm.tab.name];
			if (state && vm.tab.keepState) {
				vm.focusedRow = state.focusedRow || null;
			}
			
			vm.genericDataService.getEmpresas()
				.then(function (result) {
					vm.genericData.empresas.list = result;
					vm.genericData.empresas.list.unshift({ 'nombre': 'TODAS', 'id': '0' });
					vm.genericData.empresas.selected = { 'nombre': 'TODAS', 'id': '0' };
				});
			loadData();
        })();

		$scope.$on('detail-resize', function (event, args) {
            if (vm.tab.isActive()) {
                if (!common.isNullOrUndefined(vm.gridApi))
                    $timeout(function () { vm.gridApi.core.handleWindowResize(); }, 0);
            }
		});

		function onCompanyChange() {
			//applyFilters();
			applyPagination();
			filterGrid();
		}

		function refreshData() {
			loadData(); 
		}

		function doSkipTake() {
			vm.skip = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
			vm.take = paginationOptions.pageSize;
		}


        function loadData() {
			vm.loaded = false; 
            clearAll(); 

            getGenericData();

            vm.skip = (paginationOptions.pageNumber - 1) * paginationOptions.pageSize;
            vm.take = paginationOptions.pageSize;

			vm.loadingInformation = false;
			clientService.getList(vm.skip, vm.take, sorting, vm.appliedFilters, vm.listaClientesActivos, vm.searchText, vm.frequencyFields)
				.then(function (result) {
                    vm.allClientsResultList = result.data.list;
                    vm.rowsToShow = result.data.list; 
                    vm.gridData = vm.allClientsResultList;
                    vm.gridOptions.totalItems = result.data.count;
                    vm.rowCount = vm.gridOptions.totalItems;
					vm.firstLoaded = true;
					//applyFilters();
					applyPagination();
					vm.loadingInformation = true;
					vm.loaded = true;
				});
		}

		function applyFilters() {
			/*jshint maxcomplexity:false */
			vm.allClientsResultListWithFilters = [];
			var i = 0;
			if (vm.genericData.empresas.selected.nombre !== 'TODAS') {
				for (i = 0; i < vm.allClientsResultList.length; ++i) {
					if ((vm.genericData.empresas.selected.id === vm.allClientsResultList[i].empresaId) &&
						(vm.genericData.estadoClientes.selected.nombre === 'Todos')) {
						vm.allClientsResultListWithFilters.push(vm.allClientsResultList[i]);
					}
					else if ((vm.genericData.empresas.selected.id === vm.allClientsResultList[i].empresaId) &&
						(vm.genericData.estadoClientes.selected.nombre === 'Activos') &&
						(0 === vm.allClientsResultList[i].estado)) {
						vm.allClientsResultListWithFilters.push(vm.allClientsResultList[i]);
					}
					else if ((vm.genericData.empresas.selected.id === vm.allClientsResultList[i].empresaId) &&
						(vm.genericData.estadoClientes.selected.nombre === 'Clientes dados de baja') &&
						(1 === vm.allClientsResultList[i].estado)) {
						vm.allClientsResultListWithFilters.push(vm.allClientsResultList[i]);
					}
				}
			}
			else {
				for (i = 0; i < vm.allClientsResultList.length; ++i) {
					if ((vm.genericData.estadoClientes.selected.nombre === 'Clientes dados de baja') &&
						(1 === vm.allClientsResultList[i].estado)) {
						vm.allClientsResultListWithFilters.push(vm.allClientsResultList[i]);
					}
					else if ((vm.genericData.estadoClientes.selected.nombre === 'Activos') &&
						(0 === vm.allClientsResultList[i].estado)) {
						vm.allClientsResultListWithFilters.push(vm.allClientsResultList[i]);
					}
					else if (vm.genericData.estadoClientes.selected.nombre === 'Todos') {
						vm.allClientsResultListWithFilters.push(vm.allClientsResultList[i]);
					}
				}
			}
			vm.gridOptions.totalItems = vm.allClientsResultListWithFilters.length;
		}

        function applyPagination() {
			//$scope.gridData = [];
			//vm.gridData = [];
			//for (var i = 0; i < vm.allClientsResultListWithFilters.length; ++i) {
			//	if (i >= vm.skip && i < (vm.skip + vm.take)){
			//		$scope.gridData.push(vm.allClientsResultList[i]);
			//		vm.gridData.push(vm.allClientsResultList[i]);
			//	}
			//}
            $scope.gridData = []; 
            for (var i = 0; i < vm.gridData.length; ++i) {
                if (i >= vm.skip && i < (vm.skip + vm.take)) {
                    $scope.gridData.push(vm.gridData[i]);
                }
            }

            //$scope.gridData = vm.gridData.slice(vm.skip, vm.skip + vm.take);
		}

		$scope.$on('fleetdata-refreshed', function (event, args) {
			////Save selected rows to mantain the selection after refreshing the data
			//var selected = vm.gridApi.selection.getSelectedRows();
			//filterGrid();
			//vm.clearAll();
			//var list = $scope.gridData;
			//if (list) {
			//	for (var i = 0; i < list.length; i++) {
			//		var found = $filter('filter')(selected, { 'clienteId': list[i].clienteId });
			//		if (found[0]) {
			//			vm.gridApi.grid.modifyRows($scope.gridData);
			//			vm.gridApi.selection.selectRow($scope.gridData[i]);
			//		}
			//	}
			//}
		});

        function filterGrid() {
            if (vm.searchText !== '') {
                vm.gridData = $filter('searchFilter')(vm.allClientsResultList, {
                    'nif': vm.searchText,
					'id': vm.searchText,
					'nombre': vm.searchText,
					'direccion': vm.searchText,
					'poblacion': vm.searchText,
					'provincia': vm.searchText,
					'telefono': vm.searchText,
                }, true);
            }
            else {
                vm.gridData = vm.allClientsResultList;
            }

            if (!common.isNullOrUndefined(vm.genericData.empresas.selected) && vm.genericData.empresas.selected.id != 0) {
                //vm.gridData = $filter('searchFilter')(vm.gridData, {
                //    'empresaNombre': vm.genericData.empresas.selected.nombre
				//}, true);
				vm.gridData = vm.gridData.filter(data => data.empresaNombre.trim() == vm.genericData.empresas.selected.nombre.trim())
            }
            
            vm.gridOptions.totalItems = vm.gridData.length;
            vm.rowCount = vm.gridData.length;


            //applyFilters();
            applyPagination();

            vm.gridApi.core.notifyDataChange(uiGridConstants.dataChange.ALL);
		}


		function focusRow(client){
			vm.focusedRow = client.clienteId;
		}

		function isFocused(client){
			return vm.focusedRow === client.clienteId;
		}


        function selectAll() {
            vm.gridApi.selection.selectAllRows();
        }
        function clearAll() {
            if (!common.isNullOrUndefined(vm.gridApi))
                vm.gridApi.selection.clearSelectedRows();
        }
        function invertSelection() {
            var selected = vm.gridApi.selection.getSelectedRows();

            vm.selectAll();

            for (var i = 0; i < selected.length; i++) {
                vm.gridApi.selection.unSelectRow(selected[i]);
            }
        }
        function selectOrClear() {
            if (vm.gridApi.selection.getSelectAllState()) {
                vm.clearAll();
            } else {
                vm.selectAll();
            }
        }
        function showHideFilterBar() {
            vm.filtersSidebar = !vm.filtersSidebar;
            $rootScope.$broadcast('detail-resize');
		}

		function goToEdit(client) {
            vm.focusedRow = client.clienteId;
            restrictionService.hasPermission(2, 'cliente', 'flota.clientes.editar', { 'id': client.clienteId });

			//$state.go('flota.clientes.editar', { 'id': client.clienteId });
		}

        function remove(client) {
            if (!restrictionService.hasPermission(8, 'cliente')) return; 

			notificationService.sendAppNotification({
				message: 'Dando de baja cliente...',
				positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
			});
			clientService.deleteById([client.clienteId]).then(function () {
                loadData();
                clearSearcher(); 
				notificationService.sendAppNotification({
					message: 'Cliente dado de baja con éxito',
					positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
				});
			}, function () {
				notificationService.sendAppNotification({
					message: 'Ha ocurrido un error al dar de baja el cliente',
					positionY: 'top', positionX: 'right', delay: null, type: 'error'
				});
			});
		}

        function deleteAllItems() {
            if (!restrictionService.hasPermission(8, 'cliente')) return; 

            simpleModalService
                .yesNoModal('Confirmación eliminar', '¿Desea eliminar los clientes seleccionados?') // ' + vm.gridApi.selection.vm.gridApi.selection.getSelectedRows() + '
                .then(function (result) {
                    if (result) {
	                    var clientIds = [];
	                    var selected = vm.gridApi.selection.getSelectedRows();
	                    for (var i = 0; i < selected.length; i++) {
		                    clientIds.push(selected[i].clienteId);
                        }
                        notificationService.sendAppNotification({
                            message: 'Dando de baja clientes...',
                            positionY: 'top', positionX: 'right', delay: 3000, type: 'info'
                        });
	                    clientService.deleteById(clientIds)
                            .then(function () {
                                refreshGrid(); 
                                clearSearcher(); 
			                    notificationService.sendAppNotification({
				                    message: 'Clientes dados de baja con éxito',
				                    positionY: 'top', positionX: 'right', delay: 3000, type: 'success'
			                    });
		                    }, function () {
			                    notificationService.sendAppNotification({
				                    message: 'Ha ocurrido un error al dar de baja los clientes',
				                    positionY: 'top', positionX: 'right', delay: null, type: 'error'
			                    });
		                    });
                    }
                });
		}

		$scope.$on('$destroy', function () { //Save state
			$rootScope.stateStorage[vm.tab.name] = {
				focusedRow: vm.focusedRow
			};
		}); 

		function changeGrid() {
			//applyFilters();
			applyPagination();
			filterGrid();
		}

		function getBrandLogo(tipo) {
            if(tipo === null){ return null; }
            return userService.userData.brands.insurance[tipo] || null;
		}

		function deleteSearchData() {
			vm.searchText = '';
			filterGrid();
		}

		function refreshGrid() {
			vm.searchText = '';
			loadData();
		}

		function estadoBajaChange() {
			changeGrid();
		}

        function getGenericData() {

            vm.genericData.empresas.loading = true;
            genericDataService.getEmpresas()
                .then(function (res) {
                    vm.genericData.empresas.loading = false;
                    vm.genericData.empresas.list = res;

                    if (vm.genericData.empresas.selected.id == null && defaultVal.empresa) {
                        vm.genericData.empresas.selected = vm.genericData.empresas.list[0];
                    }
                });
        }

        function clearSearcher() {
            vm.searchText = '';
            filterGrid();
        }

        function onSelectEmpresasClick(obj) {
            vm.genericData.empresas.selected = obj;

            if (obj !== null) {
                vm.selectEmpresasText = obj.nombre;
            } else {
                vm.selectEmpresasText = 'Todos';
            }

            filterGrid();
        }
    }
})();
